import "./portfolio.css"

import IMG1 from "../../assets/oars.png"
import IMG2 from "../../assets/nobles.png"
import IMG3 from "../../assets/williston.png"
import IMG4 from "../../assets/veracross.png"
import IMG5 from "../../assets/rei.png"
import IMG6 from "../../assets/wqst.png"
import React from "react"

//Portfolio function
const Portfolio = () => {
  const soloProjects = [
    {
      id: 1,
      title: "OARS Whitewater Rafting",
      img: IMG1,
      description:
        "A Website for one fo the largest whitewater rafting companies in the US",
      technologies: "Wordpress | PHP | CSS| JS |",
      link: "https://www.oars.com",
    },
    {
      id: 2,
      title: "Noble and Greenough School",
      img: IMG2,
      description:
        "A website for one of the leading private schools in Massachusetts featuring API integration with Student Information System pulling details in real time",
      technologies: "Wordpress | PHP | CSS| JS",
      link: "https://nobles.edu",
    },
    {
      id: 3,
      title: "Williston School",
      img: IMG3,
      description:
        "A Website for a co-ed boarding school featuring calendar intergration for athletic events pulled up from Veracross Stutent Information System",
      technologies: "Wordpress | PHP | CSS| JS",
      link: "https://williston.com",
    },
    {
      id: 4,
      title: "Veracross",
      img: IMG4,
      description:
        "A Website for a 100% fully integrated Student Information System",
      technologies: "Wordpress | PHP | CSS| JS | React",
      link: "https://veracross.com",
    },
    {
      id: 5,
      title: "REI Co-op Adventure Centers",
      img: IMG5,
      description:
        "A Website bult intiailly for Arizona Outdoor Adventures which was later acquired by REI and re-designed to fit new branding",
      technologies: "Wordpress | PHP | CSS| JS | React",
      link: "https://destinations.rei.com",
    },
    {
      id: 6,
      title: "Wequassett Resort",
      img: IMG6,
      description:
        "A Website for a luxury hotel containing integration with MeetingBroker by Amadeus to send/receive data via REST API",
      technologies: "Wordpress | PHP | CSS| JS | React",
      link: "https://wequassett.com/",
    },
  ]

  return (
    <section id="portfolio">
      <h5>My Recent Work</h5>
      <h2>Portfolio</h2>

      <div className="container portfolio__container">
        {soloProjects.map((pro) => (
          <article className="portfolio__item" key={pro.id}>
            <div className="portfolio__item-image">
              <img src={pro.img} alt={pro.title} />
            </div>
            <div className="portfolio__item-content">
              <h3>{pro.title}</h3>
              <p>{pro.description}</p>
              <p>{pro.technologies}</p>
            </div>
            <div className="portfolio__item-cta">
              <a
                href={pro.link}
                target="_blank"
                className="btn btn-primary"
                rel="noreferrer"
              >
                Live Demo
              </a>
            </div>
          </article>
        ))}
      </div>
    </section>
  )
}

export default Portfolio
